export default {
  rates: {
    aside: {
      title: "Sur la durée de votre hypothèque, vous pouvez économiser",
      subtitle: "Comparé aux taux moyen de {rate} % des grandes banques",
      info_title: "VOS OPTIONS",
      rate_title: "TAUX",
      term_title: "TERME",
      rate_button_variable: "VARIABLE",
      rate_button_fixed: "FIXE",
      term_button_3: "3 ANS",
      term_button_5: "5 ANS",
      info_p1:
        "Le meilleur produit hypothécaire n’est pas seulement lié au taux.",
      info_p2:
        "Nos experts hypothécaires vous contacterons pour discuter de ces offres plus en détail.",
      cta_call: "PARLER À UN COURTIER"
    },
    tooltips: {
      savings: {
        title: "Économies",
        p1:
          "Cette économie est calculée en comparant les taux annoncés des six grandes banques canadiennes à notre meilleur taux hypothécaire. Nous supposons que ces taux seront constants pour la durée de l'hypothèque. Nous avons utilisé un amortissement de 25 ans.",
        p2:
          "La période d'amortissement est la durée que vous prendrez pour rembourser votre prêt hypothécaire. Selon l'Association Canadienne des Conseillers Hypothécaires Accrédités, environ 60% des prêts hypothécaires ont un amortissement pouvant aller jusqu'à 25 ans."
      },
      rate: {
        title: "Taux",
        p1:
          "Environ 2/3 des Canadiens choisissent un prêt hypothécaire fixe selon l'Association Canadienne des Conseillers Hypothécaires Accrédités.",
        p2:
          "Opter pour un taux variable peut mener à de meilleurs taux hypothécaires."
      },
      term: {
        title: "Terme",
        p1:
          "Environ 2/3 des Canadiens choisissent un prêt hypothécaire fixe selon l'Association Canadienne des Conseillers Hypothécaires Accrédités."
      },
      offers: {
        title: "Offres",
        p1:
          "Ces taux supposent un bon historique de crédit. Communiquez avec nos courtiers hypothécaires indépendants pour vérifier que vous vous qualifiez pour ces taux. Nesto ne favorise aucune institution financière dans la comparaison des taux pour les utilisateurs - les taux sont classés en ordre croissant, peu importe l'institution financière. L'outil de comparaison des taux n'est pas destiné à remplacer les conseils des professionnels. Nesto encourage les utilisateurs à contacter un courtier hypothécaire avant de choisir un prendre une décision."
      },
      expertRate: {
        title: "Expert Rate",
        p1:
          "In selecting your mortgage product, you should also consider important conditions like: lump-sum pre-payment conditions, monthly pre-payment conditions, penalties for selling before the end of a term, etc. Don’t worry, our Mortgage Experts will translate these terms in plain English!"
      }
    },
    ratesView: {
      best_quote: "MEILLEURE OFFRE",
      other_offers: "AUTRES OFFRES",
      rate: "TAUX",
      monthly_payment: "PAIEMENT MENSUEL"
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/fr/rates.js